import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { orderSummaryStyles } from "@insite/content-library/Widgets/OnePageCheckout/OnePageCheckoutOrderSummary";
import { css } from "styled-components";

orderSummaryStyles.container = mergeToNew(orderSummaryStyles.container, {
    gap: 0,
    css: css`
        background: ${themeBackgrounds.white};
        ${StyledWrapper} {
            display: flex;
            justify-content: space-between;
            width: 100%;
            background: ${themeBackgrounds.lightGray};
            padding: 16px;
        }
    `,
});

orderSummaryStyles.cartTotalGridItem = mergeToNew(orderSummaryStyles.cartTotalGridItem, {
    css: css`
        padding: 8px 16px;
    `,
});

orderSummaryStyles.titleText = mergeToNew(orderSummaryStyles.titleText, {
    transform: "capitalize",
    size: fontSizes.medium,
    lineHeight: lineHeights.medium,
    css: css`
        margin-bottom: 0;
        letter-spacing: normal;
    `,
});

orderSummaryStyles.cartTotal = mergeToNew(orderSummaryStyles.cartTotal, {
    subtotalLabel: {
        weight: fontWeights.regular,
    },
    promotionLabel: {
        weight: fontWeights.regular,
    },
    discountsLabel: {
        weight: fontWeights.regular,
    },
    shippingAndHandlingLabel: {
        weight: fontWeights.regular,
    },
    otherChargesLabel: {
        weight: fontWeights.regular,
    },
    taxLabel: {
        weight: fontWeights.regular,
    },
    totalLabel: {
        weight: fontWeights.regular,
    },
    subtotalValue: {
        weight: fontWeights.semiBold,
    },
    promotionValue: {
        weight: fontWeights.semiBold,
    },
    discountsValue: {
        weight: fontWeights.semiBold,
    },
    shippingAndHandlingValue: {
        weight: fontWeights.semiBold,
    },
    otherChargesValue: {
        weight: fontWeights.semiBold,
    },
    taxValue: {
        weight: fontWeights.semiBold,
    },
    totalValue: {
        weight: fontWeights.semiBold,
    },
});
